import { useDispatch, useSelector } from "react-redux";
import { changeFormActive, changeFormMode, prefillSupportTicketForm } from "../../features/supportTicketForm/supportTicketFormSlice";
import { loadSupportTicketComments } from "../../features/supportTickets/supportTicketsSlice";
import { selectToken } from "../../features/login/loginSlice";
import { selectFilters } from "../../features/searchBar/searchBarSlice";
import { selectUser } from "../../features/home/userSlice";

export default function SupportTicketList({supportTickets}) {
    const dispatch = useDispatch();

    const token = useSelector(selectToken);
    const userInfo = useSelector(selectUser);
    const userRole = userInfo.userRole;
    const searchFilters = useSelector(selectFilters);
    const supportFilters = searchFilters.filter(filter => filter.searchMode === 'support');

    const filteredTickets = supportFilters.length < 1 ? supportTickets : supportTickets.filter(supportTicket => {
        let filterCheck = true;
        
        supportFilters.forEach(filter => {
            if (filter.active && filterCheck) {
                if (filter.searchTarget === 'Support Ticket Id') {
                    filterCheck = supportTicket.supportTicketId.includes(filter.searchTerm);
                } else if (filter.searchTarget === 'Type') {
                    filterCheck = supportTicket.ticketType.includes(filter.searchTerm);
                } else if (filter.searchTarget === 'Title') {
                    filterCheck = supportTicket.title.includes(filter.searchTerm);
                } else if (filter.searchTarget === 'Severity') {
                    filterCheck = supportTicket.severity.includes(filter.searchTerm);
                } else if (filter.searchTarget === 'Created By') {
                    filterCheck = supportTicket.username.includes(filter.searchTerm);
                } else if (filter.searchTarget === 'Bank Id') {
                    filterCheck = supportTicket.bankId.includes(filter.searchTerm);
                } else if (filter.searchTarget === 'Status') {
                    filterCheck = supportTicket.status.includes(filter.searchTerm);
                }
            }
        })
        console.log(filterCheck)
        return filterCheck;
    })

    const handleViewTicketClick = (event) => {
        const supportTicketId = event.target.value;
        const ticketToView = supportTickets.find(supportTicket => supportTicket.supportTicketId === supportTicketId );
        dispatch(loadSupportTicketComments({supportTicketId, token}));
        dispatch(changeFormActive(true));
        dispatch(changeFormMode('edit'));
        dispatch(prefillSupportTicketForm(ticketToView));
    }

     if (!filteredTickets.length || !supportTickets.length) {
        return <p>No Support Tickets</p>
     } else {
        return (
            <table>
                <thead>
                    <th>View Ticket</th>
                    <th>Ticket Number</th>
                    <th>Ticket Type</th>
                    <th>Ticket Title</th>
                    <th>Severity</th>
                    <th>Created By</th>
                    {userRole === 'SUPERADMIN' ? <th>Bank Id</th>: ""}
                    {userRole === 'ADMIN' ? <th>Support Level</th> : ""}
                    <th>Status</th>
                </thead>
                <tbody>
                    {!filteredTickets.length || supportTickets.length === 0 ? "No support Tickets" : filteredTickets.map((supportTicket) => {
                        return (
                            <tr key={supportTicket.supportTicketId}>
                                <td><button value={supportTicket.supportTicketId} onClick={handleViewTicketClick}>View</button></td>
                                <td>{supportTicket.supportTicketId}</td>
                                <td>{supportTicket.ticketType}</td>
                                <td>{supportTicket.title}</td>
                                <td>{supportTicket.severity}</td>
                                <td>{supportTicket.username}</td>
                                {userRole === 'SUPERADMIN' ? <td>{supportTicket.bankId}</td> : ""}
                                {userRole === 'ADMIN' ? <td>{supportTicket.supportLevel === '2' ? "External" : "Internal"}</td> : ""}
                                <td>{supportTicket.status}</td>
                            </tr>
                        )
                    })}
                </tbody>
            </table>
        )
    }
}